import React, { useEffect } from "react"
import { useHits, Pagination, useStats, Highlight } from "react-instantsearch"
import { Link } from "gatsby-plugin-react-i18next"
import SearchResultsStats from "./searchResultsStats"

const SearchResults = ({ setIsSearchActive }) => {
  const { results, hits } = useHits()
  const { nbHits, nbPages } = useStats()

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === "Escape") {
        event.preventDefault()
        setIsSearchActive(false)
      }
    }

    document.addEventListener("keydown", keyDownHandler)

    return () => {
      document.removeEventListener("keydown", keyDownHandler)
    }
  }, [setIsSearchActive])

  return (
    <div className="bg-white transition-all flex flex-col -mt-20 pt-16 rounded-lg shadow-lg w-[600px]">
      {results.query !== "*" ? (
        <>
          <SearchResultsStats />
          {nbHits > 0 && nbPages > 1 ? (
            <Pagination
              showFirst={false}
              showLast={false}
              classNames={{
                root: "px-3 py-3 bg-white border-b w-full",
                list: "flex jusitfy-around items-center m-auto block",
                item: "mx-1 inline-block border-2 rounded-md hover:shadow-md bg-gray-100 text-dark-sage hover:bg-lime hover:text-gray-800",
                link: "px-2",
                selectedItem: "font-bold text-white bg-tomato border-gray-300",
              }}
            />
          ) : null}

          {nbHits > 0 &&
            hits.map(hit => (
              <div className="border-b-2 max-w-[600px] group hover:bg-pale-green odd:bg-slate-100 last-of-type:mb-10 pb-2">
                <Link
                  to={`/${hit.page_path}`}
                  key={hit.objectID}
                  className="px-6 pt-3 font-semibold text-gray-700 mb-2 break-all max-w-100 block group-hover:text-dark-sage"
                >
                  <Highlight
                    attribute="title"
                    hit={hit}
                    classNames={{
                      highlighted: "bg-page-green text-darker-sage ",
                    }}
                  />
                </Link>
                <div className="">
                  <Highlight
                    attribute="summary"
                    hit={hit}
                    classNames={{
                      root: "px-6 pb-4 text-sm text-gray-800",
                      highlighted:
                        "bg-page-green text-darker-sage font-semibold",
                    }}
                  />
                </div>
              </div>
            ))}
        </>
      ) : null}
    </div>
  )
}

export default SearchResults
